export enum BillStatusDTO {
    Review = "Review",
    Pending = "Pending",
    Paid = "Paid",
    Canceled = "Canceled",
    Expired = "Expired",
    Scheduled = "Scheduled",
    ExternallyPaid = "ExternallyPaid"
}
